import { tv } from 'tailwind-variants'

import { body2 } from '@ui-kit/core/typography'

export const coveragePlans = tv({
  slots: {
    container: 'w-full flex-col gap-3',
    comparison: 'flex-col gap-4',
    trigger: 'flex-row items-center justify-between rounded-lg border border-grey-200 bg-white p-4',
    triggerLabel: body2({ bold: true, className: 'flex-1' }),
  },
})
